export default __webpack_public_path__ + "static/media/sw_5.c106809d.png";